import React, { useRef, useState, useEffect } from "react";
import {
    Box,
    Typography,
    Button,
    Paper,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import StepMenuDuda from "./StepMenuDuda";
import GuiaHeader from "./GuiaHeader";

const GuiaDuda = () => {
    const ignoreScroll = useRef(false);
    const scrollTimeoutRef = useRef(null);

    const introduccionRef = useRef(null);
    const explicacion = useRef(null);

    /* eslint-disable */
    const pasoRefs = [
        introduccionRef,
        explicacion
    ];

    const [pasoActivo, setPasoActivo] = useState("Introducción");

    const codeString = `<script>
  window.onload = function () {
    const bmvScript = document.createElement('script');
    bmvScript.src = 'https://widget.bemyvega.com/build/bmvPlugin.js';
    bmvScript.addEventListener('load', () => {
      const settings = {};
      BmvPlugin.setConfig(settings);
    });
    document.head.appendChild(bmvScript);
  };
</script>`;

    const copyToClipboard = () => {
        navigator.clipboard.writeText(codeString);
    };

    const handleScrollTo = (index) => {
        ignoreScroll.current = true;

        // Cancelar cualquier timeout anterior
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }

        // Iniciar nuevo scroll
        const targetRef = pasoRefs[index];
        targetRef.current?.scrollIntoView({ behavior: "smooth" });

        // Esperar antes de volver a activar el scroll listener
        scrollTimeoutRef.current = setTimeout(() => {
            ignoreScroll.current = false;
        }, 800); // Puedes ajustar este tiempo si lo ves necesario
    };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const handleScroll = () => {
            if (ignoreScroll.current) return;
            for (let i = pasoRefs.length - 1; i >= 0; i--) {
                const ref = pasoRefs[i].current;
                if (ref) {
                    const rect = ref.getBoundingClientRect();
                    if (rect.top <= 250) {
                        const nuevoPaso = i === 0 ? "Introducción" : `Explicación`;
                        setPasoActivo(nuevoPaso);
                        break;
                    }
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    


    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", p: 4, pb: 0, mr: { xs: -1 }, pr: {xs: 0} }}>
            <GuiaHeader plataforma="Duda" />

            <Box sx={{ display: "flex", marginTop: { xs: 10, md: 10 }, alignItems: "flex-start", ml: { xs: -6, md: 0 } }}>
                <Box sx={{ mt: -0.3, display: { xs: 'none', md: 'block' } }}>
                    <StepMenuDuda handleScrollTo={handleScrollTo} pasoActivo={pasoActivo} setPasoActivo={setPasoActivo} />
                </Box>

                <Box sx={{ display: "flex", flexGrow: 1, paddingLeft: { xs: 0, md: 28 }, flexDirection: 'column' }}>
                    <Box sx={{ flexGrow: 1, paddingLeft: 4.26, position: "relative" }}>
                        {/* Barra vertical dentro del contenido */}
                        <Box
                            sx={{
                                position: "absolute",
                                width: "4px",
                                height: "100%",
                                backgroundColor: "rgb(162, 182, 212)",
                                left: 0,
                                top: 10,
                                display: { xs: 'none', md: 'block' }
                            }}
                        />
                        {/* Introducción */}
                        <Box sx={{ position: "relative", paddingLeft: 0 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={introduccionRef} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Introducción
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1 }}>
                                    A lo largo del siguiente documento se expondrá el proceso de implementación, paso a paso, que se debe seguir para implementar la solución de accesibilidad digital de Viewser en una Web hecha con el CMS <b>Duda. </b>
                                    Recuerde que previamente debe tener una cuenta registrada y haber contratado la solución desde <a href="https://dash.bemyvega.com/login">nuestro portal de clientes</a> asociando el dominio de la web en donde implementará nuestra solución.
                                    La implementación de la solución es tan sencilla como introducir este código desde el portal de administración de su Web en Duda:
                                </Typography>
                                <Paper
                                    sx={{
                                        padding: 2,
                                        marginTop: 2,
                                        position: "relative",
                                        boxShadow: "0px 0px 24px 2px rgba(0, 0, 0, 0.2)",
                                        overflowX: "auto",
                                        maxWidth: "100%",
                                        whiteSpace: "pre-wrap", // opcional para mantener saltos de línea
                                        wordBreak: "break-word", // rompe palabras largas
                                    }}
                                >

                                    <Typography component="pre" sx={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
                                        {codeString}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{ position: "absolute", top: { xs: 4, md: 8 }, right: { xs: 4, md: 8 } }}
                                        onClick={copyToClipboard}
                                        startIcon={<ContentCopyIcon />}
                                    >
                                        Copiar
                                    </Button>
                                </Paper>
                                <Typography variant="body1" sx={{ marginTop: 2, mb: 6.5 }}>
                                    Tenga a mano este código, ya que lo usaremos en el último paso de la guía.
                                </Typography>
                            </Box>
                        </Box>

                        {/* Explicación */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: -2 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={explicacion} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Explicación
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                Hoy en día, la accesibilidad web no es solo un requisito legal en muchas regiones, sino también una necesidad para garantizar que todas las personas, independientemente de sus capacidades, puedan navegar y utilizar tu sitio sin barreras. 
                                Duda, como un CMS flexible y potente, permite construir sitios web dinámicos, pero sin las configuraciones adecuadas, puede presentar obstáculos para usuarios con discapacidad visual, motriz o cognitiva.
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                Si tu web en Duda no cumple con los estándares de accesibilidad, podrías estar excluyendo a una parte importante de tu audiencia, afectando la experiencia del usuario y el posicionamiento en buscadores (SEO). 
                                Implementar mejoras en accesibilidad no solo es una cuestión de inclusión, sino también una ventaja competitiva que amplía el alcance de tu sitio.
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                Para facilitar la accesibilidad sin necesidad de realizar cambios profundos en el código de Duda, Viewser ofrece una solución innovadora. 
                                Se trata de un widget de accesibilidad que se integra fácilmente en tu sitio, brindando herramientas que permiten a los usuarios personalizar su experiencia de navegación según sus necesidades.
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1 }}>
                                Mejorar la accesibilidad de tu web Duda es una inversión en inclusión, usabilidad y reputación. Con Viewser, puedes hacerlo de manera sencilla y efectiva. 
                                ¡Haz que tu web sea accesible para todos! <b>Lo único que tienes que hacer es insertar un fragmento de código y nosotros nos encargaremos del resto.</b>
                                </Typography>
                            </Box>
                        </Box>


                    </Box>

                    {/* Contacto */}
                    <Box ml={2.5}>
                        <Typography variant="body1" sx={{ marginTop: 10 }}>
                            <strong>Puede contactarnos</strong> mediante cualquiera de las vías que se ofrecen a continuación, contestaremos con la mayor brevedad posible.
                        </Typography>
                        <List sx={{ paddingLeft: 2 }}>
                            <ListItem disablePadding>
                                <ListItemIcon sx={{ minWidth: 20 }}>
                                    <FiberManualRecordIcon sx={{ fontSize: 10, color: "#0F52BD" }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <span>
                                            Email: <Link href="mailto:hola@bemyvega.com">hola@bemyvega.com</Link>
                                        </span>
                                    }
                                />
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemIcon sx={{ minWidth: 20 }}>
                                    <FiberManualRecordIcon sx={{ fontSize: 10, color: "#0F52BD" }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <span>
                                            Web: <Link href="https://www.goviewser.com/contacto" target="_blank" rel="noopener">www.goviewser.com/contacto</Link>
                                        </span>
                                    }
                                />
                            </ListItem>
                        </List>
                        <Typography variant="body1">
                            <strong>Muchas gracias por confiar en nosotros</strong>, estaremos encantados de solucionar cualquier duda que le surja durante el proceso de implementación.
                        </Typography>
                    </Box>

                </Box>
            </Box>
        </Box>
    );
};

export default GuiaDuda;